import apiRequest from '../utils/apiRequest';
import findIdByPath from '../utils/findIdByPath';

const fetchNotes = cb => async dispatch => {
  dispatch({ type: 'FETCHING_NOTES' });

  const notes = await apiRequest(
    'scribble',
    `scribbles/?type=${findIdByPath()}`
  );

  if (typeof cb === 'function') cb();
  return dispatch({ type: 'RECEIVE_NOTES', notes });
};

export const fetchNotesIfNeeded = cb => (dispatch, getState) => {
  const { notes: { fetching } } = getState();
  if (fetching) return false;
  return dispatch(fetchNotes(cb));
};



// WEBPACK FOOTER //
// ./src/actions/notes.js